module.exports = __webpack_public_path__ + "img/github.96a85cc3.png";